
// import DesignEditor from "./components/design-editor";
// import Controls from "./components/controls";
import ColorparkEmbed from "./components/colorpark-embed";

function App() {
  // const [image, setImage] = useState(null);
  // const [isDragging, setIsDragging] = useState(false);

  // const handleImageUpload = (file) => {
  //   const reader = new FileReader();
  //   reader.onload = (e) => {
  //     if (e.target?.result) {
  //       setImage(e.target.result);
  //     }
  //   };
  //   reader.readAsDataURL(file);
  // };

  // const handleReset = () => {
  //   setImage(null);
  // };

  return (
    <div className="App">
      {/* <header className="App-header">
        <h1 style={{ textAlign: 'center', margin: '20px 0' }}>Golf Ball Designer</h1>
      </header>
      <main style={{ 
        maxWidth: '1200px', 
        margin: '0 auto', 
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>
        <div style={{ 
          display: 'flex', 
          flexWrap: 'wrap', 
          gap: '20px',
          width: '100%',
          justifyContent: 'center'
        }}>
          <div>
            <div style={{ 
              display: 'flex', 
              flexDirection: window.innerWidth > 768 ? 'row' : 'column',
              gap: '20px',
              marginBottom: '30px'
            }}>
              {/* <div>
                <DesignEditor 
                  image={image} 
                  isDragging={isDragging} 
                  setIsDragging={setIsDragging} 
                />
              </div> */}
              {/* <div style={{ width: window.innerWidth > 768 ? '300px' : '100%' }}>
                <Controls 
                  onUpload={handleImageUpload} 
                  onReset={handleReset} 
                  disabled={isDragging} 
                />
              </div> */}
            {/* </div>
          </div>
        </div> */}
         {/* */} 
        <div style={{ width: '100%', marginTop: '30px' }}>
          <h2>Original Colorpark Tool</h2>
          <ColorparkEmbed />
        </div>
      {/* </main> */}
    </div>
  );
}

export default App;

